import {AxiosRequestConfig} from 'axios';
import {HttpPromiseState} from '../../lib/helpers';
import {environment} from '../../lib/environment';
import {PagedListResponse} from '../models/paged-list-response';
import {SuccessResponse} from '../models/response-model';
import {UploadedFile} from '../models/uploaded-file';
import {httpClient} from '../utils/httpClient';

const multipartFormDataConfig: AxiosRequestConfig = {
  headers: {
    'content-type': 'multipart/form-data'
  }
};

const blobResponseTypeConfig: AxiosRequestConfig = {
  responseType: 'blob'
};

class UploadedFiles {
  list(page: number): HttpPromiseState<PagedListResponse<UploadedFile>> {
    const url = `${environment.apiServer}/uploads/list/${page}`;
    return httpClient.state.get<PagedListResponse<UploadedFile>>(url);
  }

  uploadAudio(file: File): HttpPromiseState<SuccessResponse> {
    const url = `${environment.apiServer}/upload-file/audio`;
    const formData = new FormData();
    formData.append('file', file);
    return httpClient.state.post<SuccessResponse>(url, formData, multipartFormDataConfig);
  }

  uploadImage(file: File): HttpPromiseState<SuccessResponse> {
    const url = `${environment.apiServer}/upload-file/image`;
    const formData = new FormData();
    formData.append('file', file);
    return httpClient.state.post<SuccessResponse>(url, formData, multipartFormDataConfig);
  }

  uploadImages(file: File): HttpPromiseState<SuccessResponse> {
    const url = `${environment.apiServer}/upload-file/images`;
    const formData = new FormData();
    formData.append('file', file);
    return httpClient.state.post<SuccessResponse>(url, formData, multipartFormDataConfig);
  }

  uploadVideo(file: File): HttpPromiseState<SuccessResponse> {
    const url = `${environment.apiServer}/upload-file/video`;
    const formData = new FormData();
    formData.append('file', file);
    return httpClient.state.post<SuccessResponse>(url, formData, multipartFormDataConfig);
  }

  uploadRawFile(file: File): HttpPromiseState<SuccessResponse> {
    const url = `${environment.apiServer}/upload-file/raw`;
    const formData = new FormData();
    formData.append('file', file);
    return httpClient.state.post<SuccessResponse>(url, formData, multipartFormDataConfig);
  }

  url(id: number): string {
    return `${environment.apiServer}/uploads/${id}`;
  }

  imageUrl(id: number): string {
    return `${environment.apiServer}/uploads/${id}/image`;
  }

  audioUrl(id: number): string {
    return `${environment.apiServer}/uploads/${id}/audio`;
  }

  videoUrl(id: number): string {
    return `${environment.apiServer}/uploads/${id}/video`;
  }

  retrieve(id: number): HttpPromiseState<Blob> {
    const url = `${environment.apiServer}/uploads/${id}`;
    return httpClient.state.get<Blob>(url, blobResponseTypeConfig);
  }

  retrieveImage(id: number): HttpPromiseState<Blob> {
    const url = `${environment.apiServer}/uploads/${id}/image`;
    return httpClient.state.get<Blob>(url, blobResponseTypeConfig);
  }

  isImageUrl(value: string): boolean {
    return value !== null &&
      value !== undefined &&
      value !== '' &&
      value.startsWith(`${environment.apiServer}/uploads/`) &&
      value.endsWith('/image');
  }

  delete(id: number):
    HttpPromiseState<SuccessResponse> {
    const url = `${environment.apiServer}/uploads/${id}`;
    return httpClient.state.delete<SuccessResponse>(url);
  }
}

export const uploadedFiles = new UploadedFiles();
